function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDraftTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.198,
    height: 17.94,
    viewBox: "0 0 56.198 17.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-363.351 -173.96)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.198,
    height: 17.94,
    rx: 4,
    transform: "translate(363.351 173.96)",
    style: {
      fill: "#000040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33 0h3.416c2.758 0 4.3-1.512 4.3-3.92v-2.114c0-2.408-1.54-3.906-4.3-3.906H1.33c-.448 0-.588.154-.588.588v8.764c0 .434.14.588.588.588zm3.318-2.45H3.5V-7.5h1.148c1.134 0 1.624.532 1.624 1.526v2.016c0 .99-.49 1.508-1.624 1.508zM10.864 0h1.582c.448 0 .588-.154.588-.588V-3.3h.322a1.032 1.032 0 0 1 1.05.714l.9 1.918c.238.49.546.672 1.288.672H18.1c.462 0 .56-.308.364-.686L17.206-3.08a3.665 3.665 0 0 0-.378-.6 3.1 3.1 0 0 0 1.512-2.886 3.158 3.158 0 0 0-3.486-3.374h-3.99c-.448 0-.588.154-.588.588v8.764c0 .434.14.588.588.588zm3.682-5.642h-1.512V-7.5h1.512a.84.84 0 0 1 .924.924.857.857 0 0 1-.924.934zM19.32 0h1.47c.686 0 .882-.154 1.008-.588L22.12-1.6h3.052l.308 1.012c.112.434.336.588 1.05.588h1.512c.42 0 .546-.2.406-.574l-3.234-8.9a.643.643 0 0 0-.728-.462h-1.6a.627.627 0 0 0-.728.49L18.942-.574C18.8-.2 18.886 0 19.32 0zm5.208-3.794h-1.75l.522-1.652a7.557 7.557 0 0 0 .266-1.96h.14a8.878 8.878 0 0 0 .308 1.974zM29.862 0h1.582c.448 0 .588-.154.588-.588V-3.43h2.954c.448 0 .6-.14.6-.588v-1.26c0-.434-.154-.588-.6-.588h-2.954V-7.5h3.7c.448 0 .6-.14.6-.588v-1.26c0-.434-.154-.588-.6-.588h-5.87c-.448 0-.588.154-.588.588v8.76c0 .434.14.588.588.588zM40.1 0h1.582c.448 0 .588-.154.588-.588V-7.5h2.086c.448 0 .588-.14.588-.588v-1.26c0-.434-.14-.588-.588-.588h-6.93c-.448 0-.588.154-.588.588v1.26c0 .448.14.588.588.588h2.086v6.912c-.004.434.136.588.588.588z",
    transform: "translate(368.609 187.9)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftTag);
export default __webpack_public_path__ + "static/media/draft-tag.e41ae5ee.svg";
export { ForwardRef as ReactComponent };